import { CSSProperties } from '@mui/material';
import { atlasSemantic } from 'src/theme/atlas/tokens';

export const filterButton: CSSProperties = {
  border: 'none',
  color: atlasSemantic.color.type.default,
  fontWeight: 600,
};
